import "./nfoCountdownTimerSimple.css"
import { useHistory } from "react-router-dom";
import { useState, useEffect } from 'react'
import Image from "../../atom/image"
import { format } from "date-fns"
import { NFO_DATA } from "../../../helper/constant.js"

function calculateTimeLeft(FundEndDate) {
  const endDate = new Date(`${FundEndDate}T00:00:00`);
  const difference = endDate - new Date();
  let timeLeft = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  };

  if (difference > 0) {
    timeLeft = {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }

  return timeLeft;
}

function getISTTime() {
  const today = new Date();
  const isIST = today.getTimezoneOffset() === -330; // Check if the user's timezone offset is already IST

  if (isIST) return today; // Return the current time as it's already in IST.
  else {
    const offset = 5.5 * 60 * 60 * 1000; // Add offset for IST (5 hours 30 minutes).
    return new Date(today.getTime() + offset);
  }
}

const NFOCountDownTimer = ({ showCounterTimer, isLoginPage }) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(NFO_DATA.NFO_END_DATE))
  const history = useHistory();

  useEffect(() => {
    const id = setTimeout(() => {
      setTimeLeft(calculateTimeLeft(NFO_DATA.NFO_END_DATE))
    }, 1000);

    return () => {
      clearTimeout(id);
    };
  });

  const investNowClick = (schemeCode = NFO_DATA.NFO_SCHEME_CODE) => {
    let queryParams = window.location.search;
    let existingQueryParams = "";
    if (queryParams) {
      let firstQuesMarkIndex = queryParams?.indexOf("?");
      if (firstQuesMarkIndex > -1) {
        existingQueryParams =
          queryParams?.substring(firstQuesMarkIndex + 1) || "";
        existingQueryParams = "&" + existingQueryParams;
      }
    }
    let amcPlanCode = "GD";
    let sOptCode = "G";
    let planCode = "D"; // D or R
    let landingPage = true;

    // Take to landging page if clicked 'invest now' from login page.
    if (isLoginPage) window.location.href = `${process.env.REACT_APP_MOTILAL_MF_MODULE_URL}mutual-funds/${NFO_DATA.NFO_LANDING_PAGE_URL}`
    else {
      let redirUrl = `/quickbuy?fund=${schemeCode}&plan=${planCode}&amcPlan=${amcPlanCode}&option=${sOptCode}${existingQueryParams}&landingPage=${landingPage}`;
      history.push(redirUrl);
    }
  }

  if (!NFO_DATA.NFO_IS_ACTIVE) return <></>

  return (
    <div className='countdown-timer-wrapper'>
      <div className='countdown-timer-container'>
        <div className='ticker-wrapper max-md:!tw-w-[128px] max-md:!tw-h-[72px] max-md:tw-justify-center'>
          <div className='title-container'>
            <Image
              image={'prelogin-header/nfo_beacon.gif'}
            />
            <p className='title'>NFO Live</p>
          </div>
          <div className='ticker'>
            <div className='ticks max-md:!tw-border-l-0' sty><p className='values'>{timeLeft.days}</p> <p className='units'>Days</p></div>
            <div className='ticks'><p className='values'>{timeLeft.hours}</p> <p className='units'>Hrs</p></div>
            <div className='ticks'><p className='values'>{timeLeft.minutes}</p> <p className='units'>Mins</p></div>
            <div className='ticks'><p className='values'>{timeLeft.seconds}</p> <p className='units'>Sec</p></div>
          </div>
        </div>
        <div className='right-section'>
          <h2 className='fund-name'>{NFO_DATA.NFO_SCHEME_NAME}</h2>
          <div className='cta-buttons'>
            <button className='cta-invest-button' onClick={() => investNowClick()}>Invest Now</button>
          </div>
        </div>
      </div>
    </div>
  )
}



export default NFOCountDownTimer
